import React from 'react';

export type VideoProvider = 'youtube' | 'vimeo';

interface VideoEmbedProps {
  provider: VideoProvider;
  /** Provider-specific video id / path+query (not a full URL). */
  id: string;
}

const EMBED_CONFIG: Record<
  VideoProvider,
  { src: (id: string) => string; title: string; allow: string }
> = {
  youtube: {
    src: (id) => `https://www.youtube.com/embed/${id}`,
    title: 'YouTube video player',
    allow:
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
  },
  vimeo: {
    src: (id) => `https://player.vimeo.com/video/${id}`,
    title: 'Vimeo video player',
    allow: 'autoplay; fullscreen; picture-in-picture',
  },
};

/** Renders a responsive YouTube or Vimeo embed for a Contentful video entry. */
export const VideoEmbed = ({ provider, id }: VideoEmbedProps) => {
  const config = EMBED_CONFIG[provider];
  return (
    <iframe
      className="mx-auto my-4 block h-[400px] w-full border-0"
      src={config.src(id)}
      title={config.title}
      allow={config.allow}
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen
    />
  );
};
